import { defaultLanguage } from '@/config'

const getDefaultState = () => ({
  lang: defaultLanguage,
  dialogs: {
    welcomeInstructionsVisible: false,
    tutorialsVisible: false,
  },
})

const actions = {}

const state = getDefaultState()

const mutations = {
  resetState(data) {
    Object.assign(data, getDefaultState())
  },

  setLang(state, lang) {
    state.lang = lang
  },

  setDialogState(state, { dialogName, value }) {
    state.dialogs[dialogName] = value
  },
}

const getters = {
  getDialogVisible: state => dialog => state.dialogs[dialog],
  getLang: state => state.lang,
}

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
